import React from 'react';
import { useNavigate } from 'react-router-dom';

const ComplianceManagement = () => {
  const navigate = useNavigate();
  const features = [
    {
      title: 'Captive Administration',
      description: 'Full-service captive management including financials, regulatory filings, claims administration, and performance reporting.',
      icon: process.env.PUBLIC_URL + '/images/captive-administration.svg'
    },
    {
      title: 'Resident Compliance Verification',
      description: 'Elevate your Third-Party compliance with our AI technology that ensures every resident meets your insurance requirements.',
      icon: process.env.PUBLIC_URL + '/images/resident-compliance-verification.svg'
    },
    {
      title: 'Automated Enforcement',
      description: 'If residents fall out of compliance, we automatically add them to your master policy and push charges into the resident ledger.',
      icon: process.env.PUBLIC_URL + '/images/automated-enforcement.svg'
    },
    {
      title: 'Seamless Integration',
      description: 'Our APIs connect to many property management software platforms and data warehouses making this a seamless integration for your staff and residents.',
      icon: process.env.PUBLIC_URL + '/images/seamless-integration.svg'
    }
  ];

  return (
    <section className="compliance-management-wrapper">
      {/* Vertical Dividers */}
      <div className="compliance-divider compliance-divider-1"></div>
      <div className="compliance-divider compliance-divider-2"></div>
      <div className="compliance-divider compliance-divider-3"></div>
      <div className="compliance-divider compliance-divider-4"></div>
      <div className="compliance-divider compliance-divider-5"></div>

      {/* Header Section */}
      <div className="compliance-header-section">
        <div className="compliance-header-content">
          <h2 className="compliance-title">Complete Compliance Management</h2>
          <p className="compliance-description">
            Beyond captive formation, we handle the entire resident insurance lifecycle.
          </p>
        </div>
        <button 
          className="btn-schedule-compliance"
          onClick={() => navigate('/schedule-call')}
        >
          <span>Schedule a Call</span>
          <span className="btn-schedule-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M10 7L15 12L10 17" stroke="#111111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
        </button>
      </div>

      {/* Features Grid - Row 1 */}
      <div className="compliance-features-row compliance-features-row-1">
        <div className="compliance-feature-card compliance-feature-card-1">
          <div className="compliance-feature-content">
            <h3 className="compliance-feature-title">{features[0].title}</h3>
            <p className="compliance-feature-description">{features[0].description}</p>
          </div>
          <div className="compliance-feature-icon">
            <img src={features[0].icon} alt={features[0].title} className="compliance-feature-icon-img" />
          </div>
        </div>
        <div className="compliance-feature-card compliance-feature-card-2">
          <div className="compliance-feature-content">
            <h3 className="compliance-feature-title">{features[1].title}</h3>
            <p className="compliance-feature-description">{features[1].description}</p>
          </div>
          <div className="compliance-feature-icon">
            <img src={features[1].icon} alt={features[1].title} className="compliance-feature-icon-img" />
          </div>
        </div>
      </div>

      {/* Features Grid - Row 2 */}
      <div className="compliance-features-row compliance-features-row-2">
        <div className="compliance-feature-card compliance-feature-card-3">
          <div className="compliance-feature-content">
            <h3 className="compliance-feature-title">{features[2].title}</h3>
            <p className="compliance-feature-description">{features[2].description}</p>
          </div>
          <div className="compliance-feature-icon">
            <img src={features[2].icon} alt={features[2].title} className="compliance-feature-icon-img" />
          </div>
        </div>
        <div className="compliance-feature-card compliance-feature-card-4">
          <div className="compliance-feature-content">
            <h3 className="compliance-feature-title">{features[3].title}</h3>
            <p className="compliance-feature-description">{features[3].description}</p>
          </div>
          <div className="compliance-feature-icon">
            <img src={features[3].icon} alt={features[3].title} className="compliance-feature-icon-img" />
          </div>
        </div>
      </div>

      {/* Corner Indicators */}
      <div className="compliance-corner compliance-corner-1"></div>
      <div className="compliance-corner compliance-corner-2"></div>
      <div className="compliance-corner compliance-corner-3"></div>
      <div className="compliance-corner compliance-corner-4"></div>
    </section>
  );
};

export default ComplianceManagement;
